import { GalimardIngredient } from "./GalimardIngredient";

export const GalimardNoteDeCoeur: GalimardIngredient[] = [
  {
    name: "BOIS DOUX",
    galimardReference: "692",
    description: {
      fr: "Des bois tendres et ronds, à la chaleur discrète et légèrement sucrée. Au cœur, ils donnent du corps et préparent en douceur l’arrivée des notes de fond.",
      en: "Soft, rounded woods with a gentle, slightly sweet warmth. In the heart, they add body and smoothly pave the way for the base notes.",
    },
    icon: "bois-doux",
  },
  {
    name: "AIR DE PROVENCE",
    displayName: {
      fr: "Air de Provence",
      en: "",
    },
    galimardReference: "448",
    description: {
      fr: "Un accord aromatique inspiré du Sud, mêlant lavande, herbes ensoleillées et une douceur de foin. Il fait souffler au cœur un parfum de garrigue.",
      en: "An aromatic accord inspired by the South of France, blending lavender, sun-warmed herbs and a soft hay-like sweetness. It brings a breath of Provence to the heart.",
    },
    icon: "air-de-provence",
  },
  {
    name: "ALDEHYDAL",
    galimardReference: "295",
    description: {
      fr: "Une note aldéhydée, pétillante, savonneuse et légèrement poudrée, typique des parfums floraux classiques. Par petites touches, elle fait rayonner les fleurs.",
      en: "An aldehydic note, fizzy, soapy and slightly powdery, typical of classic floral perfumes. In small touches, it makes flowers sparkle and radiate.",
    },
    icon: "aldehydal",
  },
  {
    name: "CHEVREFEUILLE",
    displayName: {
      fr: "Chèvrefeuille",
      en: "",
    },
    galimardReference: "445",
    description: {
      fr: "Une fleur au nectar miellé, fruitée, à peine verte, qui embaume les jardins au début de l’été. Elle adoucit le cœur du parfum d’une note florale gourmande et légère.",
      en: "A flower with honeyed nectar, fruity and slightly green, that scents gardens in early summer. It softens the heart of the perfume with a light, sweet floral note.",
    },
    icon: "chevrefeuille",
  },
  {
    name: "COCKTAIL",
    galimardReference: "591",
    description: {
      fr: "Un mélange de fruits juteux, sucrés et acidulés, servi comme un cocktail d’été. Il met au cœur du parfum une note festive et fruitée.",
      en: "A blend of juicy fruits, sweet and tangy, served up like a summer cocktail. It puts a festive fruitiness at the heart of the perfume.",
    },
    icon: "cocktail",
  },
  {
    name: "ACCORD JASMIN",
    displayName: {
      fr: "Accord Jasmin",
      en: "",
    },
    galimardReference: "690",
    description: {
      fr: "Un jasmin recomposé, floral et lumineux, avec une facette fruitée et sensuelle. Il forme un cœur généreux et rayonnant.",
      en: "A recreated jasmine, floral and luminous, with a fruity, sensual facet. It forms a generous, radiant heart.",
    },
    icon: "accord-jasmin",
  },
  {
    name: "BAMBOU",
    galimardReference: "922",
    description: {
      fr: "Une note verte et aqueuse, comme une tige de bambou fraîchement coupée, à la touche légèrement boisée. Elle prolonge jusqu’au cœur la fraîcheur des notes de tête.",
      en: "A green, watery note, like a freshly cut bamboo stem, with a light woody touch. It carries the freshness of the top notes into the heart.",
    },
    icon: "bambou",
  },
  {
    name: "COMPLEXE FRUITE",
    displayName: {
      fr: "Complexe Fruité",
      en: "",
    },
    galimardReference: "627",
    description: {
      fr: "Une corbeille de fruits mûrs, ronde, juteuse et gourmande. Au cœur, elle fait le lien entre les fruits de tête et les fleurs.",
      en: "A basket of ripe fruit, round, juicy and gourmand. In the heart, it links the fruity top notes to the flowers.",
    },
    icon: "complexe-fruite",
  },
  {
    name: "FIGUE",
    galimardReference: "903",
    description: {
      fr: "La figue et son feuillage, de la verdeur laiteuse de la feuille à la douceur du fruit mûr. Elle donne au cœur une ambiance méditerranéenne, fraîche et ronde.",
      en: "Fig and its leaves, from the milky greenness of the leaf to the sweetness of the ripe fruit. It gives the heart a Mediterranean feel, fresh yet round.",
    },
    icon: "figue",
  },
  {
    name: "FLEUR DE GRENADIER",
    displayName: {
      fr: "Fleur de Grenadier",
      en: "",
    },
    galimardReference: "905",
    description: {
      fr: "Une fleur légère et un peu verte, aux nuances fruitées et acidulées qui rappellent la grenade. Au cœur, elle tisse une fraîcheur florale délicate.",
      en: "A light, slightly green flower with fruity, tart nuances recalling pomegranate. In the heart, it weaves a delicate floral freshness.",
    },
    icon: "fleur-de-grenadier",
  },
  {
    name: "FLEUR DE JACINTHE",
    galimardReference: "630",
    description: {
      fr: "La jacinthe, florale et verte, avec une fraîcheur de sève et une pointe un peu terreuse. Elle donne au cœur un caractère printanier très reconnaissable.",
      en: "Hyacinth, floral and green, with a sappy freshness and a slightly earthy hint. It gives the heart an unmistakable spring character.",
    },
    icon: "fleur-de-jacinthe",
  },
  {
    name: "FLEUR DE LILAS",
    galimardReference: "629",
    description: {
      fr: "Les grappes de lilas en fleur, tendres, vertes et légèrement poudrées, avec une nuance d’amande. Elles apportent au cœur la douceur d’un jardin en avril.",
      en: "Clusters of lilac in bloom, tender, green and lightly powdery, with an almond-like nuance. They bring the softness of an April garden to the heart.",
    },
    icon: "fleur-de-lilas",
  },
  {
    name: "FLEUR DE CERISIER",
    galimardReference: "940",
    description: {
      fr: "Une fleur délicate et poudrée, légèrement amandée et toute en fraîcheur. Au cœur, elle déploie une douceur aérienne, à l’image des cerisiers japonais en fleur.",
      en: "A delicate, powdery flower with a hint of almond and a fresh lightness. In the heart, it unfolds an airy softness, like Japanese cherry trees in bloom.",
    },
    icon: "fleur-de-cerisier",
  },
  {
    name: "FLEURI YLANG",
    galimardReference: "628",
    description: {
      fr: "L’ylang-ylang, fleur solaire et crémeuse, aux accents miellés et légèrement fruités. Il donne au bouquet une sensualité exotique et chaleureuse.",
      en: "Ylang-ylang, a creamy, sunny flower with honeyed, slightly fruity accents. It gives the bouquet a warm, exotic sensuality.",
    },
    icon: "fleuri-ylang",
  },
  {
    name: "FREESIA",
    galimardReference: "463",
    description: {
      fr: "Une fleur fraîche et légère, aux nuances fruitées et poivrées. Le freesia éclaire le cœur d’une note florale gaie et transparente.",
      en: "A fresh, light flower with fruity, peppery nuances. Freesia brightens the heart with a cheerful, sheer floral note.",
    },
    advice: ``,
    icon: "freesia",
  },
  {
    name: "GARDENIA",
    galimardReference: "904",
    description: {
      fr: "Une fleur blanche crémeuse et veloutée, avec une facette verte et une touche de noix de coco. Le gardénia enrichit le cœur d’une opulence florale tout en douceur.",
      en: "A creamy, velvety white flower with a green facet and a hint of coconut. Gardenia enriches the heart with a soft floral opulence.",
    },
    icon: "gardenia",
  },
  {
    name: "GERANIUM",
    displayName: {
      fr: "Géranium",
      en: "",
    },
    galimardReference: "694",
    description: {
      fr: "Le géranium, entre la rose et la menthe, avec une facette verte et citronnée. Au cœur, il donne aux fleurs une allure aromatique, nette et fraîche.",
      en: "Geranium, somewhere between rose and mint, with a green, lemony facet. In the heart, it gives florals a crisp, fresh aromatic twist.",
    },
    icon: "geranium",
  },
  {
    name: "GINGEMBRE",
    galimardReference: "955",
    description: {
      fr: "La racine de gingembre fraîchement coupée, piquante et zestée, aux accents citronnés. Sa chaleur pétillante réveille, au cœur, les fleurs comme les bois.",
      en: "Freshly cut ginger root, spicy, zesty and slightly lemony. Its tingling warmth livens up both florals and woods in the heart.",
    },
    icon: "gingembre",
  },
  {
    name: "JASMIN MUSQUE",
    displayName: {
      fr: "Jasmin Musqué",
      en: "",
    },
    galimardReference: "632",
    description: {
      fr: "Un jasmin enveloppé de muscs doux, plus feutré et plus soyeux qu’un jasmin seul. Il donne au cœur un floral sensuel, à la chaleur de peau.",
      en: "Jasmine wrapped in soft musks, gentler and silkier than jasmine alone. It gives the heart a sensual floral note with a skin-like warmth.",
    },
    icon: "jasmin-musque",
  },
  {
    name: "JASMIN ORANGE",
    galimardReference: "633",
    description: {
      fr: "Un jasmin aux accents de fleur d’oranger, solaire et légèrement fruité. Pour un cœur de fleurs blanches lumineux et frais.",
      en: "Jasmine with orange-blossom accents, sunny and slightly fruity. For a bright, fresh white-floral heart.",
    },
    icon: "jasmin-orange",
  },
  {
    name: "JASMIN SAUVAGE",
    galimardReference: "696",
    description: {
      fr: "Un jasmin plus libre et plus vert, aux facettes fruitées et légèrement animales. Un floral intense au caractère indompté, pour un cœur qui ne passe pas inaperçu.",
      en: "A freer, greener jasmine with fruity and slightly animalic facets. An intense floral with an untamed character, for a heart that does not go unnoticed.",
    },
    icon: "jasmin-sauvage",
  },
  {
    name: "MAGNOLIA",
    galimardReference: "907",
    description: {
      fr: "Le magnolia, grande fleur blanche à la fois citronnée et crémeuse, s’épanouit au cœur avec fraîcheur et douceur.",
      en: "Magnolia, a large white flower both lemony and creamy, blossoms in the heart with freshness and softness.",
    },
    icon: "magnolia",
  },
  {
    name: "MIMOSA",
    galimardReference: "???",
    description: {
      fr: "Les pompons dorés du mimosa, poudrés, miellés et légèrement verts. Au cœur, ils diffusent une douceur lumineuse, celle de l’hiver sur la Côte d’Azur.",
      en: "Mimosa’s golden pompoms, powdery, honeyed and slightly green. In the heart, they spread a sunny softness, the scent of winter on the French Riviera.",
    },
    icon: "mimosa",
  },
  {
    name: "MUGUET",
    galimardReference: "638",
    description: {
      fr: "Le muguet et ses clochettes blanches, frais, verts et délicatement citronnés. Il compose au cœur un floral net, clair et léger.",
      en: "Lily of the valley and its little white bells, fresh, green and delicately lemony. It creates a clean, clear, light floral heart.",
    },
    icon: "muguet",
  },
  {
    name: "MUGUET DE MAI",
    displayName: {
      fr: "Muguet de Mai",
      en: "",
    },
    galimardReference: "639",
    description: {
      fr: "Le muguet du 1er mai, plus vert et plus vif, avec la fraîcheur de ses tiges et de ses feuilles. Il glisse au cœur une note florale porte-bonheur.",
      en: "The lily of the valley of May Day, greener and livelier, with the freshness of its stems and leaves. It slips a lucky-charm floral note into the heart.",
    },
    icon: "muguet-de-mai",
  },
  {
    name: "MUGUET DES BOIS",
    displayName: {
      fr: "Muguet des bois",
      en: "",
    },
    galimardReference: "640",
    description: {
      fr: "Le muguet qui pousse à l’ombre des bois, plus vert et plus frais, avec une nuance de mousse et de terre humide. Au cœur, un floral discret et un peu sauvage.",
      en: "Lily of the valley from the shady woods, greener and cooler, with a hint of moss and damp earth. A discreet, slightly wild floral heart.",
    },
    icon: "muguet-des-bois",
  },
  {
    name: "MUGUET MUSQUE",
    displayName: {
      fr: "Muguet Musqué",
      en: "",
    },
    galimardReference: "698",
    description: {
      fr: "Un muguet entouré de muscs cotonneux, plus rond et plus doux qu’un muguet seul. Il enveloppe le cœur d’une fraîcheur florale soyeuse et propre.",
      en: "Lily of the valley surrounded by cottony musks, rounder and softer than the flower alone. It wraps the heart in a silky, clean floral freshness.",
    },
    icon: "muguet-musque",
  },
  {
    name: "NEROLI",
    galimardReference: "699",
    description: {
      fr: "Le néroli, c’est la fleur de l’oranger amer dans sa version la plus fraîche, verte et un peu zestée. Il prend le relais des agrumes avec une luminosité florale élégante.",
      en: "Neroli is bitter orange blossom at its freshest, green with a zesty edge. It takes over from the citrus notes with an elegant floral brightness.",
    },
    icon: "neroli",
  },
  {
    name: "NOTE CANNELLE",
    galimardReference: "444",
    description: {
      fr: "La cannelle, épice chaude, sucrée et boisée, qui évoque les pâtisseries et les fêtes d’hiver. Elle réchauffe le cœur du parfum, même à petite dose.",
      en: "Cinnamon, a warm, sweet, woody spice that recalls pastries and winter festivities. It warms the heart of the perfume, even in small amounts.",
    },
    // prompt: "cinnamon stick and cinnamon powder on a small wooden plank, detailed, white background"
    icon: "note-cannelle",
  },
  {
    name: "NOTE MARINE",
    galimardReference: "488",
    description: {
      fr: "Les embruns et l’air iodé du bord de mer, frais et légèrement salés. Cette note apporte au cœur une sensation d’évasion et de grand air.",
      en: "Sea spray and the salty air of the seaside, fresh and slightly briny. This note brings a sense of escape and open air to the heart.",
    },
    // prompt: "calm sea in a scent bottle, detailed, watercolor, white background"
    icon: "note-marine",
  },
  {
    name: "NOTE OCEANE",
    displayName: {
      fr: "Note Océane",
      en: "",
    },
    galimardReference: "927",
    description: {
      fr: "Une fraîcheur aquatique ample et transparente, comme le vent du large sur l’océan. Moins salée que la note marine, elle donne au cœur une clarté limpide.",
      en: "A broad, sheer aquatic freshness, like the wind blowing in off the ocean. Less salty than the marine note, it gives the heart a crystal-clear brightness.",
    },
    // prompt: "scent of note marine, ocean wave in a bottle, detailed, watercolor, white background"
    icon: "note-oceane",
  },
  {
    name: "NOTE TABAC",
    galimardReference: "643",
    description: {
      fr: "Des feuilles de tabac blond séchées, miellées, légèrement fumées et boisées. Au cœur, elles installent une chaleur dorée et enveloppante.",
      en: "Dried blond tobacco leaves, honeyed, slightly smoky and woody. In the heart, they lay down a golden, enveloping warmth.",
    },
    // prompt: "small bag of tobacco on dried tobacco leave, detailed, white background"
    icon: "note-tabac",
  },
  {
    name: "NOTE CIVETTE",
    galimardReference: "642",
    description: {
      fr: "Une note animale intense, chaude et musquée, qui rappelle la fourrure. À dose infime, elle donne de la sensualité et du relief aux fleurs et aux cuirs.",
      en: "An intense animalic note, warm and musky, reminiscent of fur. In tiny amounts, it adds sensuality and depth to florals and leathers.",
    },
    // prompt: "painting of the face of a civet, stylished, watercolor, white background"
    icon: "note-civette",
  },
  {
    name: "PIN BOISE",
    displayName: {
      fr: "Pin Boisé",
      en: "",
    },
    galimardReference: "703",
    description: {
      fr: "Les aiguilles et la résine du pin, fraîches et balsamiques, sur un fond boisé sec. Au cœur, il évoque une pinède chauffée par le soleil.",
      en: "Pine needles and resin, fresh and balsamic, over a dry woody background. It conjures up a sun-warmed pine forest at the heart of the perfume.",
    },
    // prompt: "painting of a Pinus pinaster, stylished, watercolor, white background"
    icon: "pin-boise",
  },
  {
    name: "PIVOINE",
    galimardReference: "923",
    description: {
      fr: "La pivoine, fraîche et rosée, à la fois aqueuse et légèrement fruitée. Elle offre au cœur un bouquet généreux, frais et romantique.",
      en: "Peony, fresh and rosy, watery with a light fruitiness. It offers the heart a generous, fresh and romantic bouquet.",
    },
    // prompt: "single red Peony with a few leaves, stylished, watercolor, white background"
    icon: "pivoine",
  },
  {
    name: "PRUNE",
    galimardReference: "914",
    description: {
      fr: "Une prune bien mûre, charnue et sucrée, aux accents légèrement confits et vineux. Sa rondeur fruitée donne de la profondeur au cœur.",
      en: "A ripe, plump, sweet plum with slightly candied, winey accents. Its fruity roundness gives depth to the heart.",
    },
    advice: ``,
    // prompt: "sliced Plum on a small wooden plank, detailed, white background"
    icon: "prune",
  },
  {
    name: "REGLISSE",
    displayName: {
      fr: "Réglisse",
      en: "",
    },
    galimardReference: "565",
    description: {
      fr: "La réglisse, douce et anisée, avec une profondeur un peu boisée et terreuse. Au cœur, elle ajoute une gourmandise originale et pleine de caractère.",
      en: "Licorice, sweet and anise-like, with a slightly woody, earthy depth. It adds an unusual gourmand touch full of character to the heart.",
    },
    // prompt: "liquorice on a small wooden plank, detailed, white background"
    icon: "reglisse",
  },
  {
    name: "ROSE D'ORIENT",
    displayName: {
      fr: "Rose d'Orient",
      en: "",
    },
    galimardReference: "646",
    description: {
      fr: "Une rose profonde et capiteuse, miellée et légèrement épicée. Elle donne au cœur une sensualité chaude, qui appelle les bois et l’ambre.",
      en: "A deep, heady rose, honeyed and lightly spiced. It gives the heart a warm sensuality that calls for woods and amber.",
    },
    // prompt: "Rose bush, watercolor detailed, white background"
    icon: "rose-orient",
  },
  {
    name: "ROSE PETALES",
    displayName: {
      fr: "Rose pétale",
      en: "",
    },
    galimardReference: "647",
    description: {
      fr: "La douceur veloutée de pétales de rose fraîchement effeuillés, tendres et légèrement poudrés. Cette note dessine au cœur une rose délicate et intime.",
      en: "The velvety softness of freshly plucked rose petals, tender and lightly powdery. It draws a delicate, intimate rose in the heart.",
    },
    // prompt: "bowl of rose petals, watercolor detailed, white background"
    icon: "rose-petales",
  },
  {
    name: "ROSE SAUVAGE",
    galimardReference: "648",
    description: {
      fr: "L’églantine des haies, une rose plus légère et plus verte, aux nuances fruitées et acidulées. Au cœur, elle reste fraîche et spontanée.",
      en: "Dog rose from the hedgerows, a lighter, greener rose with fruity, tangy nuances. In the heart, it stays fresh and spontaneous.",
    },
    // prompt: "closeup on wild rose in a forest, watercolor detailed, white background"
    icon: "rose-sauvage",
  },
  {
    name: "TIARE",
    displayName: {
      fr: "Tiaré",
      en: "",
    },
    galimardReference: "919",
    description: {
      fr: "La fleur de tiaré de Polynésie, blanche, crémeuse et solaire, aux accents de noix de coco. Elle évoque au cœur les colliers de fleurs des îles du Pacifique.",
      en: "Tiare, the Polynesian flower, white, creamy and sunny with hints of coconut. In the heart, it evokes the flower garlands of the Pacific islands.",
    },
    // prompt: photoshop generative fill with seeds from google image
    icon: "tiare",
  },
  {
    name: "TILLEUL",
    galimardReference: "915",
    description: {
      fr: "La fleur de tilleul, miellée, verte, à peine citronnée, comme une infusion d’été. Elle berce le cœur du parfum d’une douceur florale tendre et réconfortante.",
      en: "Linden blossom, honeyed, green and faintly lemony, like a summer herbal tea. It cradles the heart of the perfume in a tender, comforting floral softness.",
    },
    // prompt: "painting of a linden branch with leaves, watercolor, white background"
    icon: "tilleul",
  },
  {
    name: "VIOLETTE DE PARME",
    displayName: {
      fr: "Violette de Parme",
      en: "",
    },
    galimardReference: "935",
    description: {
      fr: "Une violette poudrée et sucrée, qui rappelle les bonbons d’autrefois, avec une touche verte de feuille. Au cœur, elle distille une douceur rétro et délicate.",
      en: "A powdery, sweet violet reminiscent of old-fashioned candies, with a green leafy touch. It lends the heart a delicate, nostalgic softness.",
    },
    icon: "violette-de-parme",
  },
  {
    name: "SAFRAN",
    displayName: {
      fr: "Safran",
      en: "Saffron",
    },
    galimardReference: "???",
    description: {
      fr: "Une épice précieuse, chaude et un peu cuirée, avec une douceur de miel et une pointe métallique. Le safran donne au cœur un caractère raffiné et singulier.",
      en: "A precious spice, warm and slightly leathery, with a honeyed sweetness and a metallic edge. Saffron gives the heart a refined, distinctive character.",
    },
    icon: "safran",
  },
  {
    name: "COCO",
    displayName: {
      fr: "Coco",
      en: "Coconut",
    },
    galimardReference: "695",
    description: {
      fr: "La noix de coco, lactée, crémeuse et sucrée. Sa douceur gourmande et solaire donne au cœur un air de vacances.",
      en: "Coconut, milky, creamy and sweet. Its sunny, gourmand softness gives the heart a holiday feel.",
    },
    icon: "coco",
  },
];
